// Servicio para manejar operaciones de embajadores con la base de datos
import { environment } from '../config/environment';
import { getApiHeaders, getApiHeadersForGet } from '../utils/apiUtils';

class AmbassadorService {
  constructor() {
    this.baseUrl = environment.apiBaseUrl;
  }

  // Crear un nuevo embajador
  async createAmbassador(ambassadorData) {
    try {
      const response = await fetch(`${this.baseUrl}/ambassadors`, {
        method: 'POST',
        headers: getApiHeaders(),
        body: JSON.stringify(ambassadorData)
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error creating ambassador:', error);
      throw error;
    }
  }

  // Obtener todos los embajadores
  async getAllAmbassadors() {
    try {
      const response = await fetch(`${this.baseUrl}/ambassadors`, {
        headers: getApiHeadersForGet()
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const ambassadors = await response.json();
      return ambassadors;
    } catch (error) {
      console.error('Error fetching ambassadors:', error);
      throw error;
    }
  }

  // Obtener un embajador por ID
  async getAmbassadorById(id) {
    try {
      const response = await fetch(`${this.baseUrl}/ambassadors/${id}`, {
        headers: getApiHeadersForGet()
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const ambassador = await response.json();
      return ambassador;
    } catch (error) {
      console.error('Error fetching ambassador:', error);
      throw error;
    }
  }

  // Actualizar un embajador
  async updateAmbassador(id, ambassadorData) {
    try {
      const response = await fetch(`${this.baseUrl}/ambassadors/${id}`, {
        method: 'PUT',
        headers: getApiHeaders(),
        body: JSON.stringify(ambassadorData)
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error updating ambassador:', error);
      throw error;
    }
  }

  // Obtener compensaciones por embajador
  async getCompensationsByAmbassador(ambassadorId) {
    try {
      const response = await fetch(`${this.baseUrl}/ambassador-compensation/ambassador/${ambassadorId}`, {
        headers: getApiHeadersForGet()
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const compensations = await response.json();
      return compensations;
    } catch (error) {
      console.error('Error fetching compensations:', error);
      throw error;
    }
  }

  // Crear registro de compensación
  async createCompensation(compensationData) {
    try {
      const response = await fetch(`${this.baseUrl}/ambassador-compensation`, {
        method: 'POST',
        headers: getApiHeaders(),
        body: JSON.stringify(compensationData)
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error creating compensation:', error);
      throw error;
    }
  }

  async getContestAssignments(ambassadorId) {
    try {
      const response = await fetch(`${this.baseUrl}/ambassadors/${ambassadorId}/assignments`, {
        headers: getApiHeadersForGet()
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching ambassador assignments:', error);
      throw error;
    }
  }

  async getNotifications(ambassadorId, limit = 50) {
    try {
      const response = await fetch(`${this.baseUrl}/ambassadors/${ambassadorId}/notifications?limit=${limit}`, {
        headers: getApiHeadersForGet()
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching ambassador notifications:', error);
      throw error;
    }
  }
}

export default new AmbassadorService();

